module.exports = __webpack_public_path__ + "img/vi.3a43b16f.png";